// Saves a user's form input to repopulate on refresh or revisit
// Usage: Wrap your form in a <form-save data-form-id="unique_id"> element
// Add data-save-field="true" to any input fields you want to save

class FormSave extends HTMLElement {
  constructor() {
    super();
    this.formId = this.getAttribute('data-form-id');

    if (!this.formId) {
      console.error('FormSave component requires a data-form-id attribute.');
      return;
    }
    this.formEl = this.querySelector('form');

    this.initialise();
  }

  initialise() {
    this.formEl.querySelectorAll('[data-save-field="true"]').forEach(input => {
        input.addEventListener('input', () => this.onFormChange());
    });

    // Repopulate form if data exists in localStorage
    const savedData = localStorage.getItem(`form-save-data-${this.formId}`);
    if (savedData) {
      const formObj = JSON.parse(savedData);
      for (const [key, value] of Object.entries(formObj)) {
        // If password
        if (key.toLowerCase().includes('password')) {
          continue; 
        }

        const input = this.formEl.querySelector(`[name="${key}"]`);
        if (input) {
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = value;
          } else {
            input.value = value;
          }
        }
      }
    }
  }

  onFormChange() {
    // Save to localStorage
    const formData = new FormData(this.formEl);
    const formObj = {};
    formData.forEach((value, key) => {
      // Skip password fields to prevent storing sensitive data
      if (key.toLowerCase().includes('password')) {
        return;
      }
      formObj[key] = value;
    });
    localStorage.setItem('form-save-data-' + this.formId, JSON.stringify(formObj));
  }
}

// Check if the element is defined
if (!customElements.get('form-save')) {
  customElements.define('form-save', FormSave);
}